module.exports = __webpack_public_path__ + "static/media/leaf.274db1fd.png";